import { __rest } from 'tslib';
import React from 'react';
import AntInputGroup from 'antd-core/es/input/Group';
import { useTheme } from '../../theme/Theme.js';
import { useAllowClear } from '../../hooks/useAllowClear.js';
import { useInputTitle } from '../../hooks/useInputTitle.js';
import { useSize } from '../../hooks/useSize.js';
import { extractMarginProps, extractDimensionsProps, extractPaddingProps } from '../../styling/utils.js';
import { Root } from './styled.js';

const BaseInput = React.forwardRef((_a, ref) => {
    var { allowClear, clearIconTooltip } = _a, props = __rest(_a, ["allowClear", "clearIconTooltip"]);
    const theme = useTheme();
    const allowClearProp = useAllowClear({ allowClear, clearIconTooltip });
    const { onChange, title } = useInputTitle(props);
    const size = useSize(props.size);
    const _b = extractMarginProps(props), { rest: restWithoutMargins } = _b, margins = __rest(_b, ["rest"]);
    const _c = extractDimensionsProps(restWithoutMargins), { rest: restWithoutDimensions } = _c, dimensions = __rest(_c, ["rest"]);
    const _d = extractPaddingProps(restWithoutDimensions), { rest } = _d, padding = __rest(_d, ["rest"]);
    return (React.createElement(Root, Object.assign({ "data-testid": 'tend-ui-input' }, rest, dimensions, margins, padding, { ref: ref, "$theme": theme, size: size, title: title, onChange: onChange, allowClear: allowClearProp })));
});
const Input = Object.assign(BaseInput, {
    displayName: 'Input',
    Group: AntInputGroup,
});

export { Input };
//# sourceMappingURL=Input.js.map
